import { render, staticRenderFns } from "./AliasForm.vue?vue&type=template&id=501538cd&scoped=true"
import script from "./AliasForm.vue?vue&type=script&lang=js"
export * from "./AliasForm.vue?vue&type=script&lang=js"
import style0 from "./AliasForm.vue?vue&type=style&index=0&id=501538cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501538cd",
  null
  
)

export default component.exports